<template>

<div class="page-head">
  <slot name="top"></slot>

  <h2 class="page-head-title">{{title}}</h2>
  <p v-if="subtitle" class="page-head-description">{{subtitle}}</p>

  <slot></slot>

  <!--
  <ol class="breadcrumb">
    <li><a href="#">Home</a></li>
    <li><a href="#">UI Elements</a></li>
    <li class="active">Typography</li>
  </ol>
  -->
</div>
</template>

<script>

export default {
  props: ['title', 'subtitle'],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @media (max-width: 767px) {
    .page-head {display:block;}
  }

</style>



// WEBPACK FOOTER //
// PageHeader.vue?175e7ec9